import React, { useState, useEffect } from 'react';
import { ShoppingBag, MapPin, Menu as MenuIcon, X } from 'lucide-react';
import { NAV_LINKS, LOGO_URL } from '../mock';
import { Button } from './ui/button';

export default function Header({ cartCount, onCartClick }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-40 bg-[#F6F2E8]/95 backdrop-blur border-b transition-shadow ${
        scrolled ? 'shadow-[0_6px_24px_-16px_rgba(0,0,0,0.18)] border-[#D6CFB8]' : 'border-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5">
          <img src={LOGO_URL} alt="Wholesome 360 logo" className="h-10 sm:h-11 w-auto" />
        </a>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a key={l.href} href={l.href} className="nav-link text-sm font-medium text-[#1B2A22]">
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button className="hidden md:flex items-center gap-1.5 text-sm text-[#1B2A22] px-3 py-2 rounded-full border border-[#D6CFB8] hover:bg-[#ECE7D6] transition-colors">
            <MapPin className="w-4 h-4 text-[#245A40]" />
            <span>60612</span>
          </button>
          <Button onClick={onCartClick} className="btn-primary rounded-full px-4 h-10 font-semibold relative">
            <ShoppingBag className="w-4 h-4 mr-1.5" />
            <span className="hidden sm:inline">Order</span>
            {cartCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-[#E0703B] text-[#FFFBF2] text-[10px] font-bold rounded-full w-5 h-5 grid place-items-center">
                {cartCount}
              </span>
            )}
          </Button>
          <button onClick={() => setOpen(!open)} className="lg:hidden p-2">
            {open ? <X className="w-5 h-5" /> : <MenuIcon className="w-5 h-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#D6CFB8] bg-[#F6F2E8]">
          <div className="px-4 py-3 flex flex-col gap-1">
            {NAV_LINKS.map((l) => (
              <a key={l.href} href={l.href} onClick={() => setOpen(false)} className="py-2.5 px-3 rounded-lg hover:bg-[#ECE7D6] text-sm font-medium">
                {l.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
